import React from 'react';
import Validator from 'validator';

//  encapsulated email address validation logic
//  passes a valid email address back to the main app
export default class Login extends React.Component {
  handleLogin = (e) => {
    e.preventDefault();

    const emailAddress = e.target.elements.option.value.trim();

    if (!Validator.isEmail(emailAddress)) {
      e.target.elements.option.value = '';
      alert("Please Enter A Valid Email Address.");
    } else {
      this.props.history.push(`/wow/${emailAddress}/0`)
    }
  };
  render() {
    return (
      <div>
        <div className="login">
          <h3 className="login__prompt">Enter Your Email to Continue</h3>
          <form className="login__form" onSubmit={this.handleLogin}>
            <input className="login__form__input" type="text" name="option" />
            <button className="button">Submit</button>
          </form>
        </div>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Login.js